import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Location } from '@angular/common';

@Injectable()
export class AuthServiceService {
  public tokenExists :boolean;
  constructor(private cookieService: CookieService) {	

    this.tokenExists = cookieService.check('_PTBA');
   }

  canActivate(): boolean {

    if (this.tokenExists) {		
      return true;
    }else{
		window.location.href='https://stg-account.scora.io?serviceurl='+ 'https://stg-participant.scora.io';  // Server
		//  window.location.href='http://localhost:5200?serviceurl='+ 'http://localhost:5400';  // Local      
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/app/auth-service.service.ts